import PresupuestoService from "common/services/PresupuestoService"
import PedidoService from "common/services/PedidoService"
import FacturaService from "common/services/FacturaService"
import AlbaranService from "common/services/AlbaranService"

export const TIPO_DOCUMENTO = {
  PRESUPUESTO: 0,
  PEDIDO: 1,
  ALBARAN: 2,
  FACTURA: 3,
}

export const TIPO_DOCUMENTO_DB = {
  25: "PRESUPUESTO",
  24: "PEDIDO",
  18: "ALBARAN",
  2: "FACTURA",
}

export const GET_AVAILABLE_DOCUMENTOS = {
  [TIPO_DOCUMENTO.FACTURA]: [
    TIPO_DOCUMENTO.PRESUPUESTO,
    TIPO_DOCUMENTO.PEDIDO,
    TIPO_DOCUMENTO.ALBARAN,
  ],
  [TIPO_DOCUMENTO.ALBARAN]: [TIPO_DOCUMENTO.PRESUPUESTO, TIPO_DOCUMENTO.PEDIDO],
  [TIPO_DOCUMENTO.PEDIDO]: [TIPO_DOCUMENTO.PRESUPUESTO],
  [TIPO_DOCUMENTO.PRESUPUESTO]: [],
}

export const GET_AVAILABLE_DOCUMENTOS_TO_GENERATE = {
  [TIPO_DOCUMENTO.FACTURA]: [],
  [TIPO_DOCUMENTO.ALBARAN]: [TIPO_DOCUMENTO.FACTURA],
  [TIPO_DOCUMENTO.PEDIDO]: [TIPO_DOCUMENTO.FACTURA, TIPO_DOCUMENTO.ALBARAN],
  [TIPO_DOCUMENTO.PRESUPUESTO]: [
    TIPO_DOCUMENTO.FACTURA,
    TIPO_DOCUMENTO.PEDIDO,
    TIPO_DOCUMENTO.ALBARAN,
  ],
}

export const GET_TIPO_DOCUMENTO_FN = {
  [TIPO_DOCUMENTO.PRESUPUESTO]:
    PresupuestoService.getPresupuestosWithSameLibradoLibrador,
  [TIPO_DOCUMENTO.PEDIDO]: PedidoService.getPedidosWithSameLibradoLibrador,
  [TIPO_DOCUMENTO.ALBARAN]: AlbaranService.getAlbaranesWithSameLibradoLibrador,
  [TIPO_DOCUMENTO.FACTURA]: FacturaService.getFacturasWithSameLibradoLibrador,
}

export const GET_PDF_DOCUMENTO_FN = {
  [TIPO_DOCUMENTO.PRESUPUESTO]: PresupuestoService.getPdfById,
  [TIPO_DOCUMENTO.PEDIDO]: PedidoService.getPdfById,
  [TIPO_DOCUMENTO.ALBARAN]: AlbaranService.getPdfById,
  [TIPO_DOCUMENTO.FACTURA]: FacturaService.getPdfById,
}

export const GET_DOCUMENTO_BY_ID = {
  [TIPO_DOCUMENTO.PRESUPUESTO]: PresupuestoService.getById,
  [TIPO_DOCUMENTO.PEDIDO]: PedidoService.getById,
  [TIPO_DOCUMENTO.ALBARAN]: AlbaranService.getById,
  [TIPO_DOCUMENTO.FACTURA]: FacturaService.getById,
}
